import { parse } from 'json2csv';

import i18n from '@/config/i18n';

const { t } = i18n.global;

const getFixedVal = (val, dataFormat) => {
  if (!val) {
    return '-';
  }

  const isPercent = !!dataFormat.match(/%/);
  const normalizedVal = isPercent ? val * 100 : val;

  return normalizedVal.toFixed(1).replace(/\.0/, '');
};

const downloadCsvData = ({
  id,
  items,
  compsetNames,
  isCtp,
  dates,
} = {}) => {
  const noDataErr = new Error('No data to download');

  if (!items) {
    throw noDataErr;
  }

  items
    .filter((i) => i.type !== 'breakdown' // not a breakdown table
      && (!id || id === i.id)) // filter by provided ID
    .forEach((i) => {
      const browsingDatesText = `${dates.startDate}_${dates.endDate}`;
      const previousPeriodDates = `${dates.ctpDateBegin}_${dates.ctpDateEnd}`;

      let descriptionField = `${i.columnDescription}`;

      if (!isCtp) {
        descriptionField += ` (${browsingDatesText})`;
      }

      const fields = [descriptionField, ...compsetNames];
      const opts = { fields };

      // format tablerows into a downloadable CSV
      const values = (i.tableRows || []).map((row) => {
        const result = {};

        // Create organised key values (Date: "Jan 21")
        result[descriptionField] = row.rowName;

        // Flatten values array with all the compsets data
        row.values.forEach((curr) => {
          // CTP case: create new columns for each value
          if (isCtp) {
            [
              { name: browsingDatesText, field: 'rawValue' },
              { name: previousPeriodDates, field: 'rawPastValue' },
              { name: t('Variation'), field: 'formattedDiff' },
            ].forEach((cfg) => {
              // New composed column name
              const newCompsetName = `${curr.compset} (${cfg.name})`;

              // Push new name
              if (!fields.filter((field) => field === newCompsetName).length) {
                fields.splice(fields.indexOf(curr.compset), 0, newCompsetName);
              }

              // Assign related field
              let tmpVal;

              if (cfg.field === 'formattedDiff') {
                const sign = curr.diff < 0 ? '-' : '+';
                tmpVal = `${sign}${curr[cfg.field]}`;
              } else {
                tmpVal = getFixedVal(curr[cfg.field], curr.dataFormat);
              }

              result[newCompsetName] = tmpVal;
            });
            // Remove only initial compset names
            fields.forEach((field) => {
              if (compsetNames.indexOf(field) > -1) {
                fields.splice(fields.indexOf(field), 1);
              }
            });
          } else {
            result[curr.compset] = getFixedVal(curr.rawValue, curr.dataFormat);
          }
        });

        return result;
      });

      if (!values.length) {
        return;
      }

      const csv = parse(values, opts);

      const fileName = `${i.title} (${browsingDatesText}).csv`;

      const link = window.document.createElement('a');
      link.setAttribute('href', `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURI(csv)}`);
      link.setAttribute('download', fileName);
      link.click();
    });
};

export default downloadCsvData;
